import React, { useEffect, useState } from "react";
import Input from "../../../../components/FormComponents/Input";
import MultiSelectBox from "../../../../components/FormComponents/MultiSelectBox";

const DefaultAction = ({ editFieldData, setEditFieldData, allKeysOfFields }) => {
  const [selectedActions, setSelectedActions] = useState({
    show: false,
    hide: false,
    reset: false,
    enable: false,
    disable: false
  });
  const getSelectedDataAccordingToAction = (type) => {
    const data = editFieldData.defaultAction.action;
    const actionData = data.find((item) => item.type === type);
    if (actionData) {
      return actionData.child_id;
    } else {
      return [];
    }
  };
  const handleActionChange = (actionType) => {
    setSelectedActions((prev) => ({
      ...prev,
      [actionType]: !prev[actionType]
    }));
  };

  const handleDefaultActions = (action, list) => {
    const newList = list.map((item) => item.id);
    const newObj = JSON.parse(JSON.stringify(editFieldData));

    let index = newObj.defaultAction.action.findIndex((act) => act.type === action);
    // if action is not there create action
    if (index === -1) {
      const obj = {
        type: action,
        child_id: newList
      };
      newObj.defaultAction.action.push(obj);
    } else {
      newObj.defaultAction.action[index].child_id = newList;
    }

    setEditFieldData(newObj);
  };
  useEffect(() => {
    const data = editFieldData.defaultAction.action || [];
    const result = {
      show: false,
      hide: false,
      reset: false,
      enable: false,
      disable: false
    };

    data.forEach((item) => {
      if (item.child_id && item.child_id.length > 0) {
        result[item.type] = true;
      }
    });

    setSelectedActions(result);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <>
      <div className="flex_column gap_4">
        {["show", "hide", "enable", "disable", "reset"].map((action) => (
          <div className="builder_form" key={action}>
            <Input
              type="checkbox"
              checked={selectedActions[action]}
              onChange={() => handleActionChange(action)}
              label={action.charAt(0).toUpperCase() + action.slice(1)}
            />

            {selectedActions[action] && (
              <MultiSelectBox
                selectedData={getSelectedDataAccordingToAction(action)}
                options={Object.values(allKeysOfFields) || []}
                labelKey={["label"]}
                placeholder="Select field"
                onChange={(list) => handleDefaultActions(action, list)}
              />
            )}
          </div>
        ))}
      </div>
    </>
  );
};

export default DefaultAction;
